import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { baseURL } from './backend_url';
import axios from 'axios';
import './ActiveLocations.css';
import Swal from 'sweetalert2';
import { formatDate_withTime } from "./commonFunctions";
import ReactPaginate from 'react-paginate';
import "./RequestTracking.css"
import * as XLSX from 'xlsx'; // Add this import at the top of your file

function ActiveLocations() {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [allTickets, setAllTickets] = useState([]);
  const [allTicketsOG, setAllTicketsOG] = useState([]);
  const [editedTickets, setEditedTickets] = useState({});
  const [ticketStatusFilter, setTicketStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationId, setLocationId] = useState("");
  const [locationName, setLocationName] = useState("");
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [access, setAccess] = useState("Edit");
  const ticketsPerPage = 100;
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const companyIdTemp = '690337'
    setCompanyId(companyIdTemp);
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    if ('Users' === foundUser.role) {
      setAccess(foundUser.access['RequestTracking_Access Specifier']);
    }

    let temp_company_id = '690337';
    //API call for getting data from Location DB
    const requestOptions2 = {
      method: "GET",
      mode: 'cors',
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(
      baseURL + "/get_company_location/" + temp_company_id,
      requestOptions2
    )
      .then((res) => res.json())
      .then((data) => {

        axios.get(baseURL + "/srt_get_user_location/" + foundUser.userEmail)
          .then((res2) => {
            const assigned_location_hash = res2.data;
            let temp1 = data.res
            let tempArr1 = []
            for (let i = 0; i < temp1.length; i++) {
              if (foundUser.role === 'Users') {
                if (assigned_location_hash[temp1[i].location_id] === true) {
                  tempArr1.push(temp1[i]);
                }
              }
              else {
                tempArr1.push(temp1[i]);
              }
            }


            const ext_company = '123456';
            axios.get(baseURL + "/srt_get_external_location")
              .then((res) => {
                axios.get(baseURL + "/srt_get_external_active_location/" + ext_company.toString())
                  .then((res1) => {

                    let allTemp = res.data.res;
                    let hashLocationNameId = {};
                    let tempArr = [];
                    if (allTemp.length > 0) {

                      for (let i = 0; i < allTemp.length; i++) {
                        if (foundUser.role === 'Users') {
                          if (res1.data[allTemp[i].location_id] === true && assigned_location_hash[allTemp[i].location_id] === true) {
                            tempArr.push(allTemp[i]);
                          }
                        }
                        else {
                          if (res1.data[allTemp[i].location_id] === true) {
                            tempArr.push(allTemp[i]);
                          }
                        }
                      }
                      // setLocationDetail(tempArr);
                    }
                    let location_hash = {};
                    let data2 = [...tempArr1, ...tempArr];
                    data2.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
                    setHashLocationNameVsID(hashLocationNameId);
                    setLocationDetail(data2);
                  })
              });
          })
      });

    
  }, []);

  useEffect(() => {
    
    const companyIdTemp = '690337';
    setLoading(true);
    axios.get(baseURL + "/srt_get_requested_tickets/" + companyIdTemp)
      .then((res_ticket) => {
        setAllTickets([]);
        setAllTicketsOG(res_ticket.data);
        const filteredTickets = res_ticket.data.filter(loc => {
          return loc.locationId === locationId;
        });
        setAllTickets(filteredTickets);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [locationId])

  const companyNameOptions = companyDetail.map((value) => ({
    value: value.company_name, label: value.company_name
  }));

  const handleInputChangeCompanyName = (selectedOption) => {
    setCompanyName(selectedOption.value);
  };

  const handleStatusChange = (ticketId, newStatus) => {
    setEditedTickets({
      ...editedTickets,
      [ticketId]: newStatus
    });
  };

  const handleSaveChanges = () => {
    const updatedTickets = allTickets.map(ticket => {
      if (editedTickets[ticket._id]) {
        return { ...ticket, ticket_status: editedTickets[ticket._id] === 'Open' };
      }
      return ticket;
    });

    axios.post(baseURL + "/srt_update_tickets", { tickets: updatedTickets })
      .then(response => {
        Swal.fire('Success', 'Ticket status updated successfully', 'success');
        setAllTickets(updatedTickets);
        setEditedTickets({});
      })
      .catch(error => {
        Swal.fire('Error', 'Failed to update ticket statuses', 'error');
      });
  };

  const handleStatusFilterChange = (selectedOption) => {
    setTicketStatusFilter(selectedOption.value);
  };

  const statusOptions = [
    { value: "", label: "All" },
    { value: "Requested", label: "Requested" },
    { value: "Completed", label: "Completed" }
  ];

  const filteredTickets = allTickets.filter(ticket => {
    if (ticketStatusFilter === "") return true;
    return ticketStatusFilter === "Requested" ? ticket.ticket_status : !ticket.ticket_status;
  });

  const pageCount = Math.ceil(filteredTickets.length / ticketsPerPage);
  const offset = currentPage * ticketsPerPage;
  const currentTickets = filteredTickets.slice(offset, offset + ticketsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  const handleInputChangeLocationName = (selectedOption) => {
    setLocationName(hashLocationNameVsID[selectedOption.value]);
    const locationId = selectedOption.value;
    setLocationId(locationId)
  }

  const handleDownloadExcel = () => {
    const modifiedTickets = currentTickets.map(ticket => ({
      TicketID: ticket._id, // Renamed _id to Ticket ID
      ReservationNumber: ticket.reservationNumber, // Renamed reservationNumber to Reservation Number
      CustomerName: ticket.customer_name, // Renamed customer_name to Customer Name
      Location: ticket.locationId.split("-")[1], // Renamed locationId to Location and split by "-"
      SelectedTerminal: ticket.selectedTerminal, // Renamed selectedTerminal to Selected Terminal
      SelectedPickUpPoint: ticket.selectedPillar, // Renamed selectedPillar to Selected PickUp Point
      RequestedDateTime: formatDate_withTime(new Date(ticket.requested_date)), // Renamed requested_date to Requested Date & Time
      ClosedDateTime: ticket.closed_at ? formatDate_withTime(new Date(ticket.closed_at)) : "-",
      WaitingTime: ticket.closed_at ? differenceInHoursAndMinutes(new Date(ticket.requested_date), new Date(ticket.closed_at)) : "-",
      TicketStatus: ticket.ticket_status ? 'Requested' : 'Completed' // Renamed ticket_status to Ticket Status
    }));

    const worksheet = XLSX.utils.json_to_sheet(modifiedTickets);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "All Tickets");
    XLSX.writeFile(workbook, "Shuttle Tracker Tickets.xlsx");
  };

  function differenceInHoursAndMinutes(startDate, endDate) {
    const totalMinutes = Math.floor((endDate - startDate) / 60000); // Convert milliseconds to minutes
    const hours = Math.floor(totalMinutes / 60); // Calculate hours
    const minutes = totalMinutes % 60; // Calculate remaining minutes
    return `${hours}h ${minutes}m`; // Return formatted string
}

  return (
    <div className="container mt-1">
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Please wait, fetching data...</p>
        </div>
      )}
      <div className="p-5 bg-light rounded shadow-sm">
        <h4 className="text-primary mb-4">Request Tracking</h4>
        <div className="mb-4">
          <label htmlFor="location_name" className="form-label">
            Select Location
          </label>
          <Select
            value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
            inputId="location_name"
            name="location_name"
            options={locationDetail.map(location => ({
              value: location.location_id,
              label: `${location.location_name} - ${location.location_id.split('-').length > 2 ? location.location_id : location.location_id.split('-')[1]}`
            }))}
            onChange={handleInputChangeLocationName}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="ticket_status" className="form-label">
            Filter by Ticket Status
          </label>
          <Select
            value={statusOptions.find(option => option.value === ticketStatusFilter)}
            inputId="ticket_status"
            name="ticket_status"
            options={statusOptions}
            onChange={handleStatusFilterChange}
          />
        </div>
        {currentTickets.length > 0 && (
          <>
            <div className='mb-3 d-flex justify-content-between'>
              {access === 'Edit' && (
                <>
                  <button className="btn btn-primary mt-3" onClick={handleSaveChanges}>Save Changes</button>
                  <button className="btn btn-warning mt-3" onClick={handleDownloadExcel}>Download Excel</button>
                </>
              )}
            </div>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Location</th>
                    <th>Reservation Number</th>
                    <th>Customer Name</th>
                    <th>Terminal</th>
                    <th>PickUp Point</th>
                    <th>Requested Date & Time</th>
                    <th>Completed Date & Time</th>
                    <th>Waiting Time</th>
                    <th>Closed by</th>
                    <th>Ticket Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentTickets.map(ticket => (
                    <tr key={ticket._id}>
                      <td>{ticket.locationId.split("-").length > 2 ? ticket.locationId : ticket.locationId.split("-")[1]}</td>
                      <td>{ticket.reservationNumber}</td>
                      <td>{ticket.customer_name}</td>
                      <td>{ticket.selectedTerminal}</td>
                      <td>{ticket.selectedPillar}</td>
                      <td>{formatDate_withTime(new Date(ticket.requested_date))}</td>
                      <td>{ticket.closed_at ? formatDate_withTime(new Date(ticket.closed_at)) : "-"}</td>
                      <td>{ticket.closed_at ? differenceInHoursAndMinutes(new Date(ticket.requested_date), new Date(ticket.closed_at)) : "-"}</td>
                      <td>{(ticket.ticket_status === false) ? ticket.closed_by : ""}</td>
                      <td>
                        <select className="form-select" aria-label="Default select example"
                          value={editedTickets[ticket._id] || (ticket.ticket_status ? 'Requested' : 'Completed')}
                          onChange={(e) => handleStatusChange(ticket._id, e.target.value)}
                        >
                          <option value="Requested">Requested</option>
                          <option value="Completed">Completed</option>
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}

            />
            {access === 'Edit' &&
              <button className="btn btn-primary mt-3" onClick={handleSaveChanges}>Save Changes</button>
            }
          </>
        )}
      </div>
    </div>
  );
}

export default ActiveLocations;
